/**
 * @file Contains the element of the "output drawer" or ChildApp which is typically a title followed by
 * a list of charts (see Chart.jsx).
 * Defines the number and nature of the chart to be displayed.
 */
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { INDICATOR } from './config';
import { inputsState, mapState } from './state';
import { ChartsGenerator } from './Chart';
import Disclaimer from './components/Disclaimer';

function ChildApp({ onClose }) {
  const {
    regionName,
    region,
    temporalAggregation,
    month,
    threshold,
    altitude,
    level,
    floodRecurrence,
    hydroModel,
  } = useSnapshot(inputsState);
  const { selectedLayer, lat, lon } = useSnapshot(mapState);
  const disclaimerRegions = ['KOS', 'baltic_sea_region'];

  return (
    <Box className="child-app">
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 500,
        }}
      >
        {regionName}
        <IconButton aria-label="delete" onClick={onClose} id="close-childapp-btn">
          <CloseIcon />
        </IconButton>
      </Typography>
      <div>
        <ChartsGenerator
          month={month}
          region={region}
          regionName={regionName}
          selectedLayer={selectedLayer}
          lat={lat}
          lon={lon}
          temporalAggregation={temporalAggregation}
          threshold={threshold}
          altitude={altitude}
          level={level}
          floodRecurrence={floodRecurrence}
          hydroModel={hydroModel}
          variable={INDICATOR}
        />
        {disclaimerRegions.includes(region) ? <Disclaimer region={region} /> : null}
      </div>
    </Box>
  );
}

ChildApp.propTypes = {
  onClose: PropTypes.func,
};

export default ChildApp;
